import { createRouter, createWebHistory } from "vue-router"

import Home1 from "../views/Home1.vue"
import Home2 from "../views/Home2.vue"
import Editor from "../views/student/Editor.vue"
import ScratchTask from "../views/student/ScratchTask.vue"
import StudentLogin from "../views/student/StudentLogin.vue"
import Lesson from "../views/student/Lesson.vue"
import CourseList from "../views/student/CourseList.vue"
import Course from "../views/student/Course.vue"
import CourseTask from "../views/student/CourseTask.vue"
import LearnReport from "@/views/student/Report.vue"
import Microbit from "@/views/student/Microbit.vue"
import ClearHexFirstVisit from "@/views/student/ClearHexFirstVisit.vue"

import TeacherLogin from "../views/teacher/TeacherLogin.vue"
import TeacherCourses from "../views/teacher/TeacherCourses.vue"
import TeacherCourse from "../views/teacher/TeacherCourse.vue"
import TeacherClasses from "../views/teacher/TeacherClasses.vue"
import TeacherClass from "../views/teacher/TeacherClass.vue"
import TeacherStudents from "../views/teacher/TeacherStudents.vue"
import TeacherStudent from "../views/teacher/TeacherStudent.vue"
import LayoutContainer from "../views/teacher/LayoutContainer.vue"
import Records from "../views/teacher/Records.vue"
import RecordsStudents from "../views/teacher/RecordsStudents.vue"
import RecordsTask from "../views/teacher/RecordsTask.vue"
import Plan from "../views/teacher/Plan.vue"
import test from "../views/teacher/test.vue"
import Competition from "@/views/teacher/Competition.vue"
import Resources from "@/views/teacher/Resources.vue"

const routes = [
  {
    path: "/",
    name: "Home",
    alias: "/home",
    component: () => {
      const hostname = window.location.hostname
      
      // 根据域名匹配规则
      if (hostname.includes('home1') || hostname.includes('ai.')) {
        return import("../views/Home1.vue")
      } else if (hostname.includes('home2') || hostname.includes('aiedu.')) {
        return import("../views/Home2.vue")
      } else {
        // 默认使用Home2
        return import("../views/Home2.vue")
      }
    },
  },
  {
    path: "/home1",
    name: "Home1",
    component: Home1,
  },
  {
    path: "/home2",
    name: "Home2",
    component: Home2,
  },
  {
    path: "/student/login",
    name: "StudentLogin",
    component: StudentLogin,
  },
  {
    path: "/student/lesson",
    name: "Lesson",
    component: Lesson,
  },
  {
    path: "/student/courselist",
    name: "CourseList",
    component: CourseList,
  },
  {
    path: "/student/course",
    name: "Course",
    component: Course,
  },
  {
    path: "/student/coursetask",
    name: "CourseTask",
    component: CourseTask,
  },
  {
    path: "/student/editor",
    name: "Editor",
    component: Editor,
  },
  {
    path: "/student/scratch",
    name: "ScratchTask",
    component: ScratchTask,
  },
  {
    path: "/student/report",
    name: "LearnReport",
    component: LearnReport,
  },
  {
    path: "/student/scratchbit",
    name: "Microbit",
    component: Microbit,
  },
  {
    path: "/student/clear-hex-first-visit",
    name: "ClearHexFirstVisit",
    component: ClearHexFirstVisit,
  },
  {
    path: "/teacher/login",
    name: "TeacherLogin",
    component: TeacherLogin,
  },
  {
    path: "/teacher/layout",
    name: "LayoutContainer",
    component: LayoutContainer,
    children: [
      {
        path: "/teacher/test",
        name: "test",
        component: test,
      },
      {
        path: "/teacher/courses",
        name: "TeacherCourses",
        component: TeacherCourses,
      },
      {
        path: "/teacher/course",
        name: "TeacherCourse",
        component: TeacherCourse,
      },
      {
        path: "/teacher/classes",
        name: "TeacherClasses",
        component: TeacherClasses,
      },
      {
        path: "/teacher/class",
        name: "TeacherClass",
        component: TeacherClass,
      },
      {
        path: "/teacher/students",
        name: "TeacherStudents",
        component: TeacherStudents,
      },
      {
        path: "/teacher/student",
        name: "TeacherStudent",
        component: TeacherStudent,
      },
      {
        path: "/teacher/competition",
        name: "Competition",
        component: Competition,
      },
      {
        path: "/teacher/records",
        name: "Records",
        component: Records,
      },
      {
        path: "/teacher/recordsstudents",
        name: "RecordsStudents",
        component: RecordsStudents,
      },
      {
        path: "/teacher/recordstask",
        name: "RecordsTask",
        component: RecordsTask,
      },
      {
        path: "/teacher/plan",
        name: "Plan",
        component: Plan,
      },
      {
        path: "/teacher/resources",
        name: "Resources",
        component: Resources,
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
